import validate from "/app/node_modules/.pnpm/nuxt@3.18.1_@capacitor+preferences@7.0.2_@capacitor+core@7.4.2__@netlify+blobs@9.1.2_@p_41a6b259604433fd7d5a3f02b072fa15/node_modules/nuxt/dist/pages/runtime/validate.js";
import org_45scope_45global from "/app/packages/competition/app/middleware/orgScope.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.18.1_@capacitor+preferences@7.0.2_@capacitor+core@7.4.2__@netlify+blobs@9.1.2_@p_41a6b259604433fd7d5a3f02b072fa15/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  org_45scope_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}